import type { RotasDoModulo } from '@/app/rotas';

import { AdjustmentsPage, RatesPage } from './PricingPages';

/** Precificacao: tabela de taxas, agravos e descontos. */
export const rotas: RotasDoModulo = {
  menu: {
    '/taxas': RatesPage,
    '/agravos': AdjustmentsPage,
  },
};
